document.addEventListener("DOMContentLoaded", function () {
    const swiperElement = document.querySelector(".swiper.reelSwiper-video");

    if (swiperElement && swiperElement.classList.contains("reel-circle-swiper")) {
        swiperElement.classList.remove("reelSwiper-video");
    }

    if (document.querySelector(".reelSwiper-video")) {
        var videoSwiper = new Swiper(".reelSwiper-video", {
            slidesPerView: 1.5,
            spaceBetween: 10,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                425: { slidesPerView: 2.5 },
                769: { slidesPerView: 4.7 },
            },
            observer: true,
            observeParents: true
        });
    }

    if (document.querySelector(".reel-circle-swiper")) {
        var circleSwiper = new Swiper(".reel-circle-swiper", {
            slidesPerView: 4,
            spaceBetween: 18,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                425: { slidesPerView: 4.1 },
                500: { slidesPerView: 5 },
                600: { slidesPerView: 5.8 },
                769: { slidesPerView: 7.5 },
                990: { slidesPerView: 9.5 },
            },
            observer: true,
            observeParents: true
        });
    }

    let videoContainer = document.querySelector(".reel-video-container");
    let videoElement = videoContainer ? videoContainer.querySelector(".reel-video") : null;
    let progressBar = videoContainer ? videoContainer.querySelector(".reel-progress") : null;
    let closeButton = videoContainer ? videoContainer.querySelector(".show-video-close") : null;
    let pauseIcon = videoContainer ? videoContainer.querySelector(".puse-icon") : null;

    // console.log(videoElement,"videoElement");

document.querySelectorAll(".reel-media-product-block [data-video-trigger], .reel-media-product-block .puse-icon-image").forEach(trigger => {
    trigger.addEventListener("click", function (e) {
        let parentBlock = this.closest(".reel-media-product-block");
        let videoUrl = parentBlock ? parentBlock.querySelector("[data-video-trigger]").getAttribute("data-video-url") : null;
        let productTitle = parentBlock.getAttribute("data-product-title");
        let productPrice = parentBlock.getAttribute("data-product-price");
        let productImage = parentBlock.getAttribute("data-product-image");
        let productUrl = parentBlock.getAttribute("data-product-url");

        let productTitle2 = parentBlock.getAttribute("data-product-title-2");
        let productPrice2 = parentBlock.getAttribute("data-product-price-2");
        let productImage2 = parentBlock.getAttribute("data-product-image-2");
        let productUrl2 = parentBlock.getAttribute("data-product-url-2");

        let productTitle3 = parentBlock.getAttribute("data-product-title-3");
        let productPrice3 = parentBlock.getAttribute("data-product-price-3");
        let productImage3 = parentBlock.getAttribute("data-product-image-3");
        let productUrl3 = parentBlock.getAttribute("data-product-url-3");

        if (productTitle || productTitle2 || productTitle3) {
            if (videoUrl && videoElement) {
                videoContainer.style.display = "none";
                videoElement.onerror = function() {
                    console.error("❌ Video failed to load");
                    return;
                };
                videoElement.onloadeddata = function() {
                    console.log("✅ Video loaded successfully! Showing now...");
                    videoContainer.style.display = "block"; 

                    if (window.innerWidth <= 768) {
                        document.body.classList.add('body-no-scroll');
                    }

                    // Update product info
                    if (productTitle) {
                        videoContainer.querySelector(".product-info-title").textContent = productTitle;
                        videoContainer.querySelector(".product-info-price").textContent = productPrice;
                        videoContainer.querySelector(".product-info img").src = productImage;
                        videoContainer.querySelector(".product-info").href = productUrl;
                        videoContainer.querySelector(".product-info").style.display = "flex";
                    } else {
                        videoContainer.querySelector(".product-info").style.display = "none";
                    }

                    if (productTitle2) {
                        videoContainer.querySelector(".product-info-title-2").textContent = productTitle2;
                        videoContainer.querySelector(".product-info-price-2").textContent = productPrice2;
                        videoContainer.querySelector(".product-info-2 img").src = productImage2;
                        videoContainer.querySelector(".product-info-2").href = productUrl2;
                        videoContainer.querySelector(".product-info-2").style.display = "flex";
                    } else {
                        videoContainer.querySelector(".product-info-2").style.display = "none";
                    }

                    if (productTitle3) {
                        videoContainer.querySelector(".product-info-title-3").textContent = productTitle3;
                        videoContainer.querySelector(".product-info-price-3").textContent = productPrice3;
                        videoContainer.querySelector(".product-info-3 img").src = productImage3;
                        videoContainer.querySelector(".product-info-3").href = productUrl3;
                        videoContainer.querySelector(".product-info-3").style.display = "flex";
                    } else {
                        videoContainer.querySelector(".product-info-3").style.display = "none";
                    }
                    videoElement.play().catch(error => {
                        console.error("⏯️ Video play failed:", error);
                    });

                    if (pauseIcon) {
                        pauseIcon.style.display = "none";
                    }
                };

                videoElement.src = videoUrl;
                videoElement.load(); // Start loading
            }
        }
    });
});

    if (closeButton) {
        closeButton.addEventListener("click", function () {
            if (videoContainer) {
                videoContainer.style.display = "none";
            }
            if (videoElement) {
                videoElement.pause();
                videoElement.currentTime = 0;
                if (progressBar) {
                    progressBar.style.width = "0%";
                }
                if (pauseIcon) {
                    pauseIcon.style.display = "none";
                }
            }
            document.body.classList.remove('body-no-scroll');
        });
    }

    if (videoElement && progressBar) {
        videoElement.addEventListener("timeupdate", function () {
            let progress = (videoElement.currentTime / videoElement.duration) * 100;
            progressBar.style.width = progress + "%";
        });
    }

        videoElement.addEventListener("click", function () {
            if (videoElement.paused) {
                videoElement.play();
                if (pauseIcon) {
                    pauseIcon.style.display = "none";
                }
            } else {
                videoElement.pause();
                if (pauseIcon) {
                    pauseIcon.style.display = "block";
                }
            }
        });

        videoElement.addEventListener("ended", function () {
            videoElement.currentTime = 0;
            videoElement.play();
            if (pauseIcon) {
                pauseIcon.style.display = "none";
            }
        });

    const slider = document.querySelector(".reel-overflow");

    if (!slider) return;

    let isDown = false;
    let startX, scrollLeft;

    slider.addEventListener("mousedown", (e) => {
        isDown = true;
        slider.classList.add("active");
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => {
        isDown = false;
        slider.classList.remove("active");
    });

    slider.addEventListener("mouseup", () => {
        isDown = false;
        slider.classList.remove("active");
    });

    slider.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2;
        slider.scrollLeft = scrollLeft - walk;
    });

    let touchStartX = 0;
    let touchScrollLeft = 0;

    slider.addEventListener("touchstart", (e) => {
        touchStartX = e.touches[0].pageX;
        touchScrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("touchmove", (e) => {
        const touchMoveX = e.touches[0].pageX;
        const walk = (touchMoveX - touchStartX) * 2;
        slider.scrollLeft = touchScrollLeft - walk;
    });
});

/* Hide ios control */

let touchStartX = 0;
let touchScrollLeft = 0;
let isTouchMoving = false;

slider.addEventListener("touchstart", (e) => {
    touchStartX = e.touches[0].pageX;
    touchScrollLeft = slider.scrollLeft;
    isTouchMoving = false;
}, { passive: false });

slider.addEventListener("touchmove", (e) => {
    if (Math.abs(e.touches[0].pageX - touchStartX) > 5) {
        e.preventDefault();
        isTouchMoving = true;
        const touchMoveX = e.touches[0].pageX;
        const walk = (touchMoveX - touchStartX) * 2;
        slider.scrollLeft = touchScrollLeft - walk;
    }
}, { passive: false });

slider.addEventListener("touchend", (e) => {
    if (!isTouchMoving) {
        if (videoElement) {
            if (videoElement.paused) {
                videoElement.play();
                if (pauseIcon) {
                    pauseIcon.style.display = "none";
                }
            } else {
                videoElement.pause();
                if (pauseIcon) {
                    pauseIcon.style.display = "block";
                }
            }
        }
    }
    isTouchMoving = false;
});
if (videoElement) {
    videoElement.addEventListener("click", function (e) {
        e.preventDefault();
        if (videoElement.paused) {
            videoElement.play();
            if (pauseIcon) {
                pauseIcon.style.display = "none";
            }
        } else {
            videoElement.pause();
            if (pauseIcon) {
                pauseIcon.style.display = "block";
            }
        }
    });
    videoElement.addEventListener("webkit-playsinline", function() { return true; });
    videoElement.setAttribute("playsinline", "");
    videoElement.setAttribute("webkit-playsinline", "");
}